<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Glossary">
<p class="h1" id="ch-4"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii"><a href="#/text/9780253044174_Contents#ch4"><b>GLOSSARY</b></a></span></p>
<table>
<tbody><tr>
<td class="glo">Atta</td>
<td class="glo1">Wheat flour</td></tr>
<tr>
<td class="glo">Attap</td>
<td class="glo1">Malayan hut made of palm leaves</td></tr>
<tr>
<td class="glo">Blitzkrieg</td>
<td class="glo1">Literal meaning: lightning war; this term is usually applied to explain the fast, mobile armored war practiced by the Germans in Europe and Russia between 1939 and 1942</td></tr>
<tr>
<td class="glo">Bushido</td>
<td class="glo1">Way of the Japanese warrior</td></tr>
<tr>
<td class="glo">Dharma</td>
<td class="glo1">Religion</td></tr>
<tr>
<td class="glo">Izzat</td>
<td class="glo1">An Urdu word that stands for personal reputation</td></tr>
<tr>
<td class="glo"><i>Jawan</i></td>
<td class="glo1">Literal meaning: young man; the term refers to an Indian private</td></tr>
<tr>
<td class="glo"><i>Kesselschlacht/Kettelschlacht</i></td>
<td class="glo1">Cauldron Battle, which involved pinning down the enemy’s army frontally and enveloping its two wings and rear</td></tr>
<tr>
<td class="glo"><i>Kikan</i></td>
<td class="glo1">Agency/department/section</td></tr>
<tr>
<td class="glo">Kukri</td>
<td class="glo1">Curved knife used by the Gurkha soldier</td></tr>
<tr>
<td class="glo">Luftwaffe</td>
<td class="glo1">German Air Force during the Second World War</td></tr>
<tr>
<td class="glo"><i>Mai-baap</i></td>
<td class="glo1">Literal meaning: father figure; a <i>jawan</i> looked up to his commanding British officer as a <i>mai-baap</i></td></tr>
<tr>
<td class="glo">Parang</td>
<td class="glo1">A machete or cleaver used by the Malays</td></tr>
<tr>
<td class="glo">Raj</td>
<td class="glo1">Literal meaning: realm; the term refers to the British government in India</td></tr>
<tr>
<td class="glo">Sahib</td>
<td class="glo1">British officer of the Indian Army</td></tr>
<tr>
<td class="glo">Sampan</td>
<td class="glo1">Large Chinese country boat used by the “natives” in Malaya</td></tr>
<tr>
<td class="glo">Sepoy</td>
<td class="glo1">This term refers to the Indian infantry; the word is derived from the Persian word <i>sipahi</i></td></tr>
<tr>
<td class="glo">Sirdar</td>
<td class="glo1">Chieftain</td></tr>
<tr>
<td class="glo">Wehrmacht</td>
<td class="glo1">German armed force during the Second World War<span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv"></span></td></tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044174_Glossary.vue?60b4cea6